export const DEVICE_TYPES = {
  PAX: "pax",
  ZEBRA: "zebra"
};

export default DEVICE_TYPES;
